import { useEffect, useRef, useState } from "react";
import { useRouter } from "next/router";
import classNames from "classnames";
import { ArrowSortIcon } from "@shared/ui/Icon/ui/Common/ArrowSortIcon";
import { SortIcon } from "@shared/ui/Icon/ui/Common/SortIcon";
import { blogSortOptions } from "./constants";
import classes from "./blog-sort.module.scss";

export const BlogSort = () => {
    const router = useRouter();
    const currentOrder = (router.query.order === "asc" ? "asc" : "desc") as "asc" | "desc";
    const [isOpen, setIsOpen] = useState(false);
    const wrapperRef = useRef<HTMLDivElement>(null);

    const handleChange = (value: "asc" | "desc") => {
        setIsOpen(false);
        router.push({
            pathname: router.pathname,
            query: { ...router.query, order: value, page: 1 }
        });
    };

    useEffect(() => {
        const handleClickOutside = (e: MouseEvent) => {
            if (wrapperRef.current && !wrapperRef.current.contains(e.target as Node)) {
                setIsOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    return (
        <div className={classes["blog-sort"]} ref={wrapperRef}>
            <button
                className={classes["blog-sort__button"]}
                onClick={() => setIsOpen((prev) => !prev)}
            >
                <SortIcon className={classes["blog-sort__icon"]} />
                {blogSortOptions.find((o) => o.value === currentOrder)?.label}
                <ArrowSortIcon className={classes["blog-sort__arrow"]} />
            </button>
            {isOpen && (
                <div className={classes["blog-sort__dropdown"]}>
                    {blogSortOptions.map((opt) => (
                        <button
                            key={opt.value}
                            className={classNames(classes["blog-sort__item"], {
                                [classes["blog-sort__item--active"]]: opt.value === currentOrder
                            })}
                            onClick={() => handleChange(opt.value as "asc" | "desc")}
                        >
                            {opt.label}
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
};